import { useCallback, useMemo } from 'react'

import { useQuery } from '@shared/modules/use-query/hooks'
import { UseQueryOptions } from '@shared/modules/use-query/types'
import { useBackgroundNavigate } from '@shared/hooks'
import { localURLMaker } from '@shared/utils/url-maker'

import { WarehousesService } from '../services'
import { Warehouse } from '../types'
import { message } from 'antd'

export const useWarehouseDetails = (id?: string | number) => {
  const navigate = useBackgroundNavigate()

  const { data, loading } = useQuery<Warehouse>(
    useCallback(async () => {
      const result = await WarehousesService.getOneById(id as string)

      if (result.status === 200) {
        return result.data
      } else {
        throw new Error(result.data)
      }
    }, [id]),
    useMemo<UseQueryOptions>(
      () => ({
        initialData: null,
        enabled: !!id,
      }),
      [id],
    ),
  )

  const edit = useCallback(() => {
    if (!id) {
      message.error('Anbar kodu mövcud deyil')
      return
    }
    navigate(localURLMaker('/warehouses/:id/update', { id }), { withBackground: true })
  }, [navigate, id])

  return { data, loading, edit }
}
